import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  root: {
    width: 250,
    flex: "1 1 auto",
    maxHeight: 300,
    padding: 10,
    display: "flex",
    flexFlow: "column"
  },
  menuList: {
    flexShrink: 1,
    maxHeight: "200px",
    overflow: "auto",
  },
  item: {
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center"
  },
  itemIcon: {
    marginRight: 10
  }
}))
